import React,{useState,useEffect} from 'react'
import SubHeader from '../../layout/components/SubHeader'
import { useEyeconxStore } from '../../../store/eyeconxStore'

import PatientManagement from "./PatientManagement";
function PatientFiles() {
  const todaysAppointment = useEyeconxStore(state => state.todaysAppointment)
  const [patientList,setPatientList] = useState(todaysAppointment)
  const [pageNo,setPageNo] = useState(1)
  const [pageSize,setPageSize] = useState(10)
  const [totalPages,setTotalPages] = useState(1)


  useEffect(()=>{
    setPatientList(todaysAppointment)
  },[todaysAppointment])
  return (
    <>
        <PatientManagement/>
    </>
  )
}

export default PatientFiles